import cookies from "@/util/cookies.js";
import http from "@/plugins/axios_plugin";
import auth from "@/plugins/auth_plugin";

class ServiceUsers {
  // Login

  async login(user) {
    let response = await http.post("/api/logar", user);
    auth.setUser(response.data.user);
  }

  buscarUsuario(chave_ativacao) {
    return http.get(
      "/api/usuarios/info?chaveativacao=" + chave_ativacao,
      "UsersController@info"
    );
  }

  setUser(user) {
    cookies.set("api_token", user.api_token, 365);
    localStorage.setItem("user", JSON.stringify(user));
  }

  // Novo Usuário
  newUser(user) {
    return http
      .post("/api/usuarios/salvar", user)
      .then((response) => response.data);
  }

  // Completar Cadastro

  salvarCadastro(dados) {
    return http.post("/api/cadastro/salvar", dados);
    /* .then ((response) => {
            callback(response.data);
        }).catch ((error) => {
            if (error.reponse.status == 401) {
                this.logout();
            } else {
                let list = []
                callback(list)
            }
        }); */
  }

  // Enviar Link Resetar Senha

  sendLinkReset(email, reenviar = false) {
    // Services.configAxios(return http.defaults);
    return http.post("/api/password/email", {
      email: email,
      reenviar: reenviar,
    });
  }

  reenviarEmailCodigoAtivacao(email) {
    // Services.configAxios(return http.defaults);
    return http.post("/api/password/email/codigo-ativacao-reenviar", {
      email: email,
    });
  }

  codigoAtivacao(email, codigo) {
    // Services.configAxios(return http.defaults);
    return http.post("/api/password/email/codigo-ativacao", {
      email: email,
      codigo: codigo,
    });
  }

  codigoReset(email, codigo) {
    // Services.configAxios(return http.defaults);
    return http.post("/api/password/email/codigo-reset", {
      email: email,
      codigo: codigo,
    });
  }

  novaSenhaReset(email, nova_senha) {
    // Services.configAxios(return http.defaults);
    return http.post("/api/password/email/nova-senha-reset", {
      email: email,
      nova_senha: nova_senha,
    });
    // return http.post('/api/password/email', { email: email });
  }

  resetPassword(dados) {
    return http.post("/api/password/reset", dados);
  }

  listar() {
    return http.get("/api/usuarios/listar");
  }

  listarTodos() {
    return http.get("/api/usuarios/listar-todos");
  }

  resetarSenha(params) {
    return http.post("/api/usuarios/resetar-senha", params);
  }

  inativar(id_user) {
    return http.post("/api/usuarios/" + id_user + "/inativar");
  }

  cadastrar(usuario) {
    return http.post("/api/usuarios/cadastrar", usuario);
  }

  editar(id_user) {
    return http.get("/api/usuarios/" + id_user + "/editar");
  }

  atualizar(usuario) {
    return http.post("/api/usuarios/" + usuario.id + "/atualizar", usuario);
  }

  excluir(usuario) {
    return http.post("/api/usuarios/" + usuario.id + "/excluir", usuario);
  }

  changePassword(usuario, user_id) {
    return http.post("/api/usuarios/" + user_id + "/alterarsenha", usuario);
  }
}

export default new ServiceUsers();
